import { ALargeSmallIcon } from "lucide-react";
import { Slider } from "@primitives/slider";
import { useThemeState } from "@/zustand/ThemeState";
import { useTranslation } from "react-i18next";

export default function ZoomSection() {
  const { t } = useTranslation();
  const { baseFontSize, setBaseFontSize } = useThemeState();
  return (
    <div className="my-2 py-2">
      <h5 className="mb-2 text-xs font-light text-foreground/50">
        {t("appearance.zoom")}
      </h5>

      <div className="flex gap-2 p-2">
        <ALargeSmallIcon />
        <Slider
          value={[baseFontSize]}
          onValueChange={(e) => {
            setBaseFontSize(e[0]);
          }}
          defaultValue={[16]}
          min={14}
          max={19}
        />
      </div>
    </div>
  );
}
